// Image preloader utility for critical images
export const preloadImage = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });
  };

  export const preloadCriticalImages = async (imageUrls) => {
    const promises = imageUrls.map((url) => preloadImage(url).catch(() => null));
    return Promise.allSettled(promises);
  };

  // Preload a single video by creating a hidden video element
  export const preloadVideo = (url) => {
    if (!url) return;
    const video = document.createElement('video');
    video.preload = 'auto';
    video.muted = true;
    video.src = url;
    video.load();
  };

  // Preload multiple videos
  export const preloadVideos = (urls) => {
    urls.filter(Boolean).forEach(preloadVideo);
  };

  // Preload images when they're about to be needed
  export const preloadNextStepImages = (currentStep, quizData) => {
    const nextStep = getNextStep(currentStep);
    if (!nextStep || !quizData[nextStep]) return;

    const imagesToPreload = quizData[nextStep]
      .map((option) => {
        if (option.image) return option.image;
        if (option.leftGirl) return option.leftGirl;
        if (option.rightGirl) return option.rightGirl;
        return null;
      })
      .filter(Boolean);

    if (imagesToPreload.length > 0) {
      preloadCriticalImages(imagesToPreload);
    }
  };

  const getNextStep = (currentStep) => {
    const stepOrder = ["welcome", "step1", "step2", "step3", "step4", "step5"];
    const currentIndex = stepOrder.indexOf(currentStep);
    return stepOrder[currentIndex + 1];
  };
  